import { useCallback, useEffect, useState } from 'react'
import { WarrantListItem, WatchListItem } from '@finance-lab/utils/types'
import { WatchListsApi } from '../api/WatchListApi'
import { NewsItem } from 'types/NewsItem'
import { IssueEntity } from 'types/IssueEntity'
import { CompanyEntity } from 'types/CompanyEntity'

const watchListsApi = new WatchListsApi()

export const useWatchListFilter = (onlyInWatchLists: boolean) => {
    const [watchListsItems, setWatchListItems] = useState<WatchListItem[] | null>(null)

    useEffect(() => {
        void (async () => {
            const [result] = await watchListsApi.getAll()

            if (result) {
                setWatchListItems(result.items)
            }
        })()
    }, [])

    const watchListFilter = useCallback(
        (item: Partial<NewsItem> & Partial<IssueEntity> & Partial<WarrantListItem> & Partial<CompanyEntity>) => {
            if (!onlyInWatchLists) return true
            if (!watchListsItems) return false

            return watchListsItems.find(({ companyId, investorId, issueId, warrantId }) => {
                return (
                    item.entityId === issueId ||
                    item.entityId === warrantId ||
                    item.companyId === companyId ||
                    item.id === companyId ||
                    item.id === warrantId ||
                    item.id === issueId ||
                    (item.investors || item.issueData?.investors || item.warrantData?.investors)?.some(
                        (i) => i.investorId === investorId,
                    ) ||
                    item.linkedIssue?.investors?.some((i) => i.investorId === investorId)
                )
            })
        },
        [watchListsItems, onlyInWatchLists],
    )

    return { watchListFilter }
}
